import React, { FunctionComponent, useState } from "react";
import { styled, media, skeletonShimmer } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { useProject } from "@iventis/permissions/src/use-project";
import { FALLBACK_PROJECT_IMAGE } from "@iventis/utilities";

export const CoverImageComponent: FunctionComponent = () => {
    const project = useProject();

    // If there is no project image set, we want to show the fallback image
    const [imageState, setImageState] = useState<"loading" | "loaded" | "errored">(project?.imageUrl ? "loading" : "errored");

    const getImageUrl = () => {
        // If the image has errored, we want to show the fallback image
        if (imageState === "errored") {
            return FALLBACK_PROJECT_IMAGE;
        }
        return project?.imageUrl;
    };

    const handleImageLoaded = () => {
        // If the image is still loading, we want to set the state to loaded
        // Else do nothing as the image has errored
        if (imageState === "loading") {
            setImageState("loaded");
        }
    };

    return (
        <>
            {imageState !== "loading" && <Overlay />}
            {imageState === "loading" && <SkeletonImage />}
            <CoverImage src={getImageUrl()} onLoad={handleImageLoaded} onError={() => setImageState("errored")} />
        </>
    );
};

const SkeletonImage = styled.span`
    ${skeletonShimmer({ sequence: 0 })};
    background-color: ${({ theme }: { theme: Theme }) => theme.shades.two};
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

const CoverImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const Overlay = styled.span`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(187deg, rgba(0, 0, 0, 0) 57%, ${({ theme }: { theme: Theme }) => theme.shades.one});

    ${media.extraSmall} {
        background-image: linear-gradient(196deg, rgba(0, 0, 0, 0) 30%, ${({ theme }: { theme: Theme }) => theme.shades.one});
    }
`;
